<template>
  <div>
      <h4 class="mt-5">
          Sorry you currently don't have access to this page, please contact your Organisation Administrator to request access.
      </h4>
      
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>